import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "../utils/baseApi";

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getProviders = () => {
  const apiKey = localStorage.getItem("apiKey");
  return axios.get(`${API_URL}/providers`, {
    headers: {
      "x-api-key": apiKey,
    },
  });
};

const createProvider = ({ name, image, parentcategory }) => {
  return axios.post(
    `${API_URL}/providers`,
    { name, image, parentcategory },
    { headers: authHeader() }
  );
};

const updateProvider = (id, { name, image, parentcategory }) => {
  return axios.put(
    `${API_URL}/providers/${id}`,
    { name, image, parentcategory },
    { headers: authHeader() }
  );
};

const deleteProvider = (id) => {
  return axios.delete(`${API_URL}/providers/${id}`, { headers: authHeader() });
};

const providerService = {
  getProviders,
  createProvider,
  updateProvider,
  deleteProvider,
};

export default providerService;
